import { type ColorStore } from './types';

const initialState: ColorStore = {
	colorMap: {},
};

export { initialState };
